module.exports = __webpack_public_path__ + "static/media/next.9bb10854.png";